export const SET_GOOGLE_CONTACT = "SET_GOOGLE_CONTACT";
export const SET_DARK_MODE = "SET_DARK_MODE";
